import { Node } from './node';
export class Button implements Node {
  private text: string;
  private callbackKey: string;
  constructor(text: string, callbackKey: string) {
    this.text = text;
    this.callbackKey = callbackKey;
  }
  public toXML(): string {
    return `<button text="${this.text}" callbackKey="${this.callbackKey}"></button>`;
  }
}
